(() => {
  const update = (elem) => {
    const displayMode = window.swinger.user.getDisplayMode();
    elem.setAttribute('aria-pressed', {
      light: false,
      dark: true,
      auto: 'mixed',
    }[displayMode]);
  };
  window.swinger.observer.initialize('.swinger-button-scheme-switch', (elem) => {
    update(elem);
    document.addEventListener('swinger.user:authchange', () => { update(elem); });
  }, false);
})();
